import getAppConfiguration from "../adlevo-vue/appConfiguration";

/**
 * Google api key
 *
 * @type {string}
 */
// export const googleApiKey = '0';
// export const googleApiKey = 'AIzaSyDuYx8O2HcpKDbbRsEJj8zbpjo5Y8MrUcE';
export const googleApiKey = getAppConfiguration().googleApiKey;
/**
 * Application type xls for download the xls file.
 *
 * @type {string}
 */
export const applicationTypeXls = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

/**
 * Markers configurations for tour type marker
 *
 * @type {{popupAnchor: number[], iconAnchor: number[], iconSize: number[]}}
 */
export const tourMarkerOptions = {
	iconSize: [48, 48],
	iconAnchor: [24, 48],
	popupAnchor: [-3, -76],
};

/**
 * Marker configuration for single location type marker
 *
 * @type {{popupAnchor: number[], iconAnchor: number[], iconSize: number[]}}
 */
export const singleLocationMarkerOptions = {
	iconSize: [30, 30],
	iconAnchor: [15, 15],
	popupAnchor: [0, -15],
};

/**
 * Layout for error notification.
 *
 * @param errorMessage
 * @returns {string}
 */
export const notyErrorLayout = errorMessage => {
	return `<svg class="noty_logo" width="40" height="40" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
			<circle cx="12.5" cy="12.5" r="11.5" stroke="#FC4F5C" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
			<path d="M9 9L16 16" stroke="#FC4F5C" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
			<path d="M16 9L9 16" stroke="#FC4F5C" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
		</svg>
		<span class="noty_text">
			${errorMessage}
		</span>`;
};

/**
 * Layout for success notification.
 *
 * @param successMessage
 * @returns {string}
 */
export const notySuccessLayout = successMessage => {
	return `<svg class="noty_logo" width="50px" height="50px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 50 50" xml:space="preserve">\
            <circle style="fill:#25AE88;" cx="25" cy="25" r="25"/>
            <polyline style="fill:none;stroke:#FFFFFF;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;" points="38,15 22,33 12,25 "/>
            </svg>
            <span class="noty_text">
            ${successMessage}
            </span>`;
};

/**
 * Noty small notification
 *
 * @param message
 * @return {string}
 */
export const notyNotificationLayout = message => {
	return `
            <span class="noty_small_notification noty_text">
            ${message}
            </span>`;
}


export const notyLoadingLayout = successMessage => {
	return `<span class="noty_text">
            ${successMessage}
            </span>`;
};


export const notyCLoseButton = `<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M1 1L13 13" stroke="#858585" stroke-width="2" stroke-linecap="round"/>
		<path d="M13 1L0.999999 13" stroke="#858585" stroke-width="2" stroke-linecap="round"/>
	</svg>`;

/**
 * Service types
 *
 * @type {{activity: string, restaurant: string, tour: string, rental: string}}
 */
export const serviceTypes = {
	tour: 'App\\Tour',
	restaurant: 'App\\Restaurant',
	rental: 'App\\Rental',
	activity: 'App\\Activity',
};

export const bookingDateDisplayFormat = 'ddd, MMM DD';
export const lightPickInputFormat = 'MM-DD-YYYY';
export const storageDateFormat = 'YYYY-MM-DD';

/**
 * Text color options for sceditor
 *
 * @type {string}
 */
export const scEditorColors = '#191919,#858585,#DDDDE7,#FCFCFC,#FC4F5C';
